import PropTypes from 'prop-types';
import { useEffect } from 'react';
import constants from '../config/constants';
import NoResults from '../containers/NoResults/NoResults';
import { withApplicationContext } from '../utils/ApplicationContext';
import { withLabels } from '../utils/LabelsContext';

const NotFound = ({ appCtx, labels }) => {
  useEffect(() => {
    appCtx.setBusy(false);
    appCtx.attachResizeListener();
  }, []);

  return <NoResults title={labels.PRODUCT_WITHOUT_RESULT_TITLE} regionCode={appCtx.regionCode} />;
};

NotFound.defaultProps = {
  appCtx: {},
  labels: {},
};

NotFound.propTypes = {
  appCtx: PropTypes.object,
  labels: PropTypes.object,
};

NotFound.getInitialProps = async (config, { res }, appCtx) => {
  res.statusCode = constants.HTTP_RES_CODE.NOT_FOUND_CODE;
  return { appCtx };
};

export default withApplicationContext(withLabels(NotFound));
export { NotFound };
